import { type ZodString, z } from 'zod';

import { CreateTeamInputSchema, UpdateTeamInputSchema } from 'APIzod';

export const createTeamFormSchema = () => {
    const base = CreateTeamInputSchema();
    return base.extend({
        name: (base.shape.name as ZodString)
            .min(1, 'Must contain at least 2 characters')
            .max(255, 'Cannot contain more than 255 characters'),
        fleets: z.array(z.string()),
        users: z.array(z.string()),
    });
};

export const editTeamFormSchema = () => {
    const base = UpdateTeamInputSchema();
    return base.extend({
        id: z.string().optional(),
        name: (base.shape.name as ZodString)
            .min(1, 'Must contain at least 1 character')
            .max(255, 'Cannot contain more than 255 characters'),
        fleets: z.array(z.string()),
        users: z.array(z.string()),
    });
};
